"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * 解析参数
 * @param query
 * @returns
 */
var parseQuery = function (query) {
    if (query === void 0) { query = ''; }
    return query
        .replace('?', '')
        .split('&')
        .map(function (qs) {
        var _a;
        var _b = qs.split('='), k = _b[0], v = _b[1];
        return _a = {}, _a[k] = decodeURIComponent(v), _a;
    })
        .reduce(function (result, curr) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), curr)); }, {});
};
exports.default = parseQuery;
//# sourceMappingURL=parseQuery.js.map